var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box col-md-6 col-lg-4"},[_c('div',{staticClass:"content text-center"},[_c('div',{staticClass:"shield"},[_c('img',{attrs:{"src":_vm.icon}})]),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))])])])}
var staticRenderFns = []

export { render, staticRenderFns }